/**
 * 编辑器阅读统计配置
*/

import {useEditorUserInfoCard} from '@/hooks/editorUserCard';
import {useCallback} from 'react';

export const useStatisticsOptions = ({
    show,
}: {
    show: boolean;
}) => {
    // 获取用户卡片的渲染函数
    const renderUserInfoCard = useEditorUserInfoCard({
        showPermissionBtn: false,
    });

    const renderUserInfoCardAdapter = useCallback((element: any, options?: any) => {
        const newElem = {
            mentionType: 'statistics',
            mentionId: element.userId,
            mentionName: element.name,
            mentionSubtitle: element.description,
            mentionDescription: element.userId,
        };
        return renderUserInfoCard(newElem, options);
    }, [renderUserInfoCard]);

    return {
        show,
        renderUserInfoCard: renderUserInfoCardAdapter,
    };
};
